module.exports = __webpack_public_path__ + "media/images/logo-large-7e5d54be.svg";